import { Button, Progress, Statistic } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'
export const RefreshButton = styled(Button)`
  display: flex;
  padding: 3px 10px;
  gap: 7px;
  align-items: center;
  font-weight: 400;
  font-size: 0.9em;
  color: grey;
  border: 1 px dotted red;
`
const { Countdown } = Statistic
export const StyledCountdown = styled(Countdown)`
  & .ant-statistic-content {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6em;
    color: grey;
    & span {
      height: fit-content;
      width: fit-content;
    }
  }
`
type CountdownButtonProps = {
  onCountdownFinish?: () => void
  label: string
  countDownTimeInSeconds: number
  size?: 'small' | 'middle' | 'large'
}

function CountdownButton({
  onCountdownFinish,
  label,
  countDownTimeInSeconds,
  size = 'middle',
}: CountdownButtonProps) {
  const countdownTimeInMilliseconds = countDownTimeInSeconds * 1000
  const [refreshCounter, setRefreshCounter] = useState(
    Date.now() + countdownTimeInMilliseconds
  )
  const [refreshCounterProgress, setRefreshCounterProgress] = useState(100)
  function getRefreshCounterProgress(value: number) {
    let timeDifference = value
    let Percentage = (timeDifference / countdownTimeInMilliseconds) * 100
    return Percentage
  }
  const onFinish = () => {
    setRefreshCounter(Date.now() + countdownTimeInMilliseconds)
    onCountdownFinish && onCountdownFinish()
  }
  return (
    <RefreshButton size={size} onClick={onFinish}>
      {label}
      <Progress
        type='circle'
        percent={refreshCounterProgress}
        size={25}
        showInfo={true}
        strokeWidth={15}
        format={(percent) => {
          return (
            <StyledCountdown
              format='s'
              value={refreshCounter}
              onChange={(value) => {
                setRefreshCounterProgress(
                  getRefreshCounterProgress(Number(value?.toString()))
                )
              }}
              onFinish={onFinish}
            />
          )
        }}
        strokeLinecap={'butt'}
      />
    </RefreshButton>
  )
}

export default CountdownButton
